import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { KeycloakService } from 'keycloak-angular';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  profile: any;
  private readonly tokenExpirationTimer: any;

  private profileSubject = new BehaviorSubject<any>(null);
  private idTokenSubject = new BehaviorSubject<any>(null);
  profile$: Observable<any> = this.profileSubject.asObservable();
  idToken$: Observable<any> = this.idTokenSubject.asObservable();

  constructor(private keycloakService: KeycloakService) {
    this.getUserProfile();
  }

  getUserDetails() {
    return this.keycloakService.loadUserProfile().then((profile) => {
      return profile;
    });
  }

  // microsoftLogin() {}

  // microsoftLogout() {}

  // microsoftRegister() {}
  microsoftPasswordReset() {}
  microsoftIndividualRegister() {}
  // Redirect to Keycloak Account Management page for password change
  public redirectToAccountManagement(): void {
    const accountUrl = this.keycloakService
      .getKeycloakInstance()
      .createAccountUrl();
    window.location.href = accountUrl;
  }

  // Trigger Keycloak password update action directly with PKCE
  public async redirectToChangePassword(): Promise<void> {
    this.keycloakService.login({
      action: 'UPDATE_PASSWORD',
      redirectUri: window.location.origin + '/dashboard',
    });
  }

  // Generate a random string for code_verifier
  private generateCodeVerifier(): string {
    const array = new Uint8Array(32);
    window.crypto.getRandomValues(array);
    return this.base64URLEncode(array);
  }

  // Base64URL encode an array
  private base64URLEncode(buffer: ArrayBuffer | Uint8Array): string {
    const bytes =
      buffer instanceof Uint8Array ? buffer : new Uint8Array(buffer);
    return btoa(String.fromCharCode(...bytes))
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=/g, '');
  }


  microsoftInstituteRegister() {}

  public login(): void {
    this.keycloakService.login();
  }

  public logout(): void {
    this.keycloakService.logout();
  }

  public isLoggedIn(): boolean {
    return this.keycloakService.isLoggedIn();
  }

  // check what is this function's purpose?
  // is it called else where
  public parseAccessToken(): void {
    this.keycloakService
      .getToken()
      .then((token) => {
        var statusPanel = this.toJWTString(token);
      })
      .catch((e) => {
        console.error(e);
      });
  }

  public isTokenExpired(): void {
    var isTokenExpired = this.keycloakService.isTokenExpired(10).toString();
  }

  public async updateToken() {
    try {
      let refreshed = await this.keycloakService.updateToken(5);
    } catch (error) {
      console.error('Failed to refresh the token:', error);
    }
  }

  public getUserRoles() {
    return this.keycloakService.getUserRoles();
  }

  public getServiceCenterId(): string {
    const tokenParsed = this.keycloakService.getKeycloakInstance()?.tokenParsed;
    return tokenParsed?.['serviceCenterId'] || '';
  }

  public getUserProfile(): void {
    this.keycloakService
      .loadUserProfile()
      .then((profile) => {
        this.profileSubject.next(profile);
      })
      .catch((error) => {
        console.error('Failed to load user profile:', error);
      });
  }

  private toJWTString(token: string) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );

    return jsonPayload;
  }
}
